import React from 'react';
var ToggleContext = /*#__PURE__*/React.createContext({
  isExpanded: false,
  toggle: function toggle() {}
});
ToggleContext.displayName = 'ToggleContext';
export default ToggleContext;